import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';


export default class ExperienceProjets {
  constructor(element) {
    this.element = element;
    this.canvas = this.element; /*document.querySelector('.webgl_hero');*/
    this.lien = "";

    if (!this.canvas) {
      console.log('Pas de canva 3D -Hero- dans cette page');
      return;
    }
    
    this.container = this.canvas.parentElement; 
    this.sizes = {
      width: this.container.clientWidth,
      height: this.container.clientHeight,
    };


    // Setup Draco
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');

    // Setup GLTF Loader with DRACO
    this.gltfLoader = new GLTFLoader();
    this.gltfLoader.setDRACOLoader(dracoLoader);

    
    this.scene = new THREE.Scene();
    this.clock = new THREE.Clock();


    this.setOptions();
    this.init();
  }

  setOptions(){
    if(this.element.dataset.lien == "salon"){
      this.lien = "assets/models/salon/salon.gltf";
    }  
    if(this.element.dataset.lien == "pise"){
      this.lien = "assets/models/pise/Pise.gltf";
    }
    if(this.element.dataset.lien == "vaisseau"){
      this.lien = "assets/models/vaisseau/Space.gltf";
    }  
  }

  init() {
    window.addEventListener('resize', this.resize.bind(this));

    const observer = new IntersectionObserver(this.observe.bind(this), {
      rootMargin: '-45% 0px',
    })

    this.createCamera();
    this.createLights();
    this.createObjects();
    this.createRenderer();
    this.animate();

    const experiences = document.querySelectorAll('.js-experience');
    for (let i = 0; i < experiences.length; i++) {
      const experience = experiences[i];
      observer.observe(experience);
    }
  }

  createCamera() {
    this.camera = new THREE.PerspectiveCamera(
      45,
      this.sizes.width / this.sizes.height
    );

    this.camera.position.y = 5;
    this.camera.position.z = 15;

    this.controls = new OrbitControls(this.camera, this.canvas);
    this.controls.enableDamping = true;

    this.scene.add(this.camera);
    
  }

  createLights(){
    const ambientLight = new THREE.AmbientLight('#ffffff', 2);
    this.scene.add(ambientLight);

    const directionalLight = new THREE.DirectionalLight('#ffffff', 1);
    directionalLight.position.set(1,2,5);
    directionalLight.castShadow = true;
    directionalLight.shadow.camera.far = 10;
    directionalLight.shadow.normalBias = 0.027;
    directionalLight.shadow.bias = -0.004;

    this.scene.add(directionalLight);
  }

  createRenderer() {
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      alpha: true,
    });

    //this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFShadowMap;

    this.resize();
  
    this.renderer.render(this.scene, this.camera);
  }

  createObjects() {
    const geometry = new THREE.BoxGeometry(2, 2, 2, 2);
    const material = new THREE.MeshMatcapMaterial({
      color: '#ff0000',
    });
    this.cube = new THREE.Mesh(geometry, material); // applique la forme et le materiel pour faire un mesh
    this.cube.position.x = 2;

    console.log(this.lien);
      this.gltfLoader.load(this.lien, (gltf) => {
      this.model = gltf.scene;
      this.model.scale.set(2, 2, 2);

      // Shadow
      this.model.traverse((child) => {
        if(child.isMesh && child.material.isMeshStandardMaterial){
          child.castShadow = true;
          child.receiveShadow = true;
        }
      });

      this.scene.add(this.model);
      
    });
  }

  /*createObjects() {
    this.gltfFiles = [
      'assets/models/salon/salon.gltf',
      'assets/models/pise/Pise.gltf'
    ]

    gltfFiles.forEach((file) => {
      this.gltfLoader.load(file, (gltf) => {
        const model = gltf.scene;
        model.scale.set(2, 2, 2);

        // Shadow
        model.traverse((child) => {
          if (child.isMesh && child.material.isMeshStandardMaterial) {
            child.castShadow = true;
            child.receiveShadow = true;
          }
        });

        this.scene.add(model);
        this.models.push(model); // store in array
      });
    });
  }*/

  resize() {
    // Update sizes
    this.sizes.width = this.container.clientWidth;
    this.sizes.height = this.container.clientHeight;

    this.aspect = this.sizes.width / this.sizes.height;

    // Update camera
    this.camera.aspect = this.aspect;
    this.camera.updateProjectionMatrix();

    // Update renderer
    this.renderer.setSize(this.sizes.width, this.sizes.height, false);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    

    this.renderer.render(this.scene, this.camera);

    /*this.canvas.removeAttribute('width');
    this.canvas.removeAttribute('height');*/
  }

  animate() {
    const elapsedTime = this.clock.getElapsedTime();
    this.renderer.render(this.scene, this.camera);

    this.cube.rotation.y = 0.5 * elapsedTime;

    window.requestAnimationFrame(this.animate.bind(this));
  }

  observe(entries){
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;

      if(entry.isIntersecting && this.model){
          //const posX = (Math.random() - 0.5) * 4;

        // Pos model
        gsap.to(this.model.position, {
          duration: 1,
          ease: 'Power2.inOut',
          x: target.dataset.p,
        });

        // Rot model
        gsap.to(this.model.rotation, {
          duration: 1,
          ease: 'Power2.inOut',
          x: target.dataset.rX,
          y: target.dataset.rY,
          z: target.dataset.rZ,
        });
        
        // Pos cam
        const cameraZ = 'cZ' in target.dataset ? target.dataset.cZ : 8;
        gsap.to(this.camera.position, {
          duration: 1,
          ease: 'Power2.inOut',
          z: cameraZ,
        });
      }
    }
  }
}
